import { Toaster as SonnerToaster, toast as sonnerToast } from "sonner";
import type { ToasterProps } from "sonner";

/**
 * Toast — Sonner wrapper, Anthropic Claude Peach theme.
 * R4 polish: top-right, warm shadow (--shadow-soft), 4s auto-dismiss,
 *            warm-tone semantic border, coral action button.
 *
 * Position: top-right (Vercel/Linear stilida)
 * aria-live: polite (Sonner avto)
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="top-right"
      duration={4000}
      visibleToasts={4}
      closeButton
      theme="dark"
      richColors={false}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast bg-[var(--bg-elevated)] border border-[var(--border-subtle)] text-[var(--text-primary)] shadow-[var(--shadow-soft)] rounded-xl",
          title: "text-sm font-medium text-[var(--text-primary)]",
          description: "text-xs text-[var(--text-secondary)]",
          actionButton:
            "bg-[var(--brand-primary)] text-white text-xs px-2.5 py-1 rounded-md hover:bg-[var(--brand-primary-hover)]",
          cancelButton:
            "bg-[var(--bg-surface)] text-[var(--text-secondary)] text-xs px-2.5 py-1 rounded-md hover:bg-[var(--border-strong)]",
          closeButton:
            "border-[var(--border-subtle)] bg-[var(--bg-elevated)] text-[var(--text-secondary)] hover:text-[var(--text-primary)]",
          success: "border-[var(--success)]/40",
          error: "border-[var(--danger)]/40",
          warning: "border-[var(--warning)]/40",
          info: "border-[var(--info)]/40",
        },
      }}
      {...props}
    />
  );
}

/**
 * Konsistent toast helper'lar.
 * Frontend agent uchun: `toast.success("Taklifnoma yuborildi")`.
 *
 * Use case'lar:
 *   - toast.success("Linkni nusxa olindi")
 *   - toast.success("A'zo o'chirildi")
 *   - toast.error("Xato — taklifnoma muddati o'tgan")
 *   - toast.warning("Sizning rolingizdan yuqorilarni o'zgartirib bo'lmaydi")
 *   - toast.info("Workspace o'zgartirildi: Decopool")
 */
export const toast = sonnerToast;
export type { ToasterProps };
